/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { HttpHeaders } from '@angular/common/http';
import { MetadataContainer } from '../container';

interface ServiceConfig {
  api?: string;
  model: Function;
  headers?: HttpHeaders | { [header: string]: string | string[] };
}

export function Service(configuration: ServiceConfig) {
  return function <T extends new(...args: any[]) => {}>(constructor: T) {
    const apiConf = configuration.api ? configuration.api : '';
    const id = configuration.model.prototype.entity_name;

    MetadataContainer.serviceMetadata[id] = {
      entity: configuration.model,
      api: configuration.api ? configuration.api : '',
      service: constructor,
      headers: configuration.headers ?? {},
    };

    return class extends constructor {
      api = apiConf;
    };
  };
}
